import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { primaryColor } from "../../../../utils";

const ShipmentChart = () => {
  const { t } = useTranslation();

  const dataByFilter = {
    week: [
      { day: t("sa"), value: 7 },
      { day: t("su"), value: 6 },
      { day: t("mo"), value: 8 },
      { day: t("tu"), value: 7.5 },
      { day: t("we"), value: 5 },
      { day: t("th"), value: 3.5 },
      { day: t("fr"), value: 4.5 },
    ],
    month: Array.from({ length: 4 }, (_, i) => ({
      day: t(`week${i + 1}`),
      value: Math.random() * 10 + 20,
    })),
    year: Array.from({ length: 12 }, (_, i) => ({
      day: t(`month${i + 1}`),
      value: Math.random() * 100,
    })),
  };

  const [filter, setFilter] = useState("week");

  return (
    <div className="p-5 bg-white dark:bg-gray-900 rounded-2xl">
      <div className="flex flex-wrap items-center justify-between gap-4 my-4 capitalize md:flex-nowrap">
        <h2 className="font-medium dark:text-white">
          {t("shipmentsStats")} {t(filter)}
        </h2>
        <div className="flex items-center gap-2">
          {["week", "month", "year"].map((item) => (
            <button
              key={item}
              className={`rounded-lg p-2 text-sm lowercase transition-colors`}
              onClick={() => setFilter(item)}
              style={{
                color: filter === item ? "#ffffff" : undefined,
                backgroundColor: filter === item ? primaryColor : undefined,
              }}
            >
              <span className="dark:text-white">{t(item)}</span>
            </button>
          ))}
        </div>
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={dataByFilter[filter]}
          margin={{ top: 10, right: 50, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorLine" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={primaryColor} stopOpacity={0.4} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
          </defs>

          <XAxis
            axisLine={false}
            tickLine={false}
            dataKey="day"
            padding={{ left: 30, right: 30 }}
            stroke="#8884d8"
          />
          <YAxis axisLine={false} tickLine={false} stroke="#8884d8" />
          <Tooltip
            contentStyle={{
              backgroundColor: "#1f2937", // dark gray for tooltip
              borderColor: primaryColor,
              color: "#fff",
            }}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke={primaryColor}
            strokeWidth={2}
            dot={false}
            fill="url(#colorLine)"
            isAnimationActive={true}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ShipmentChart;
